// Demo.js
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ApiContext } from "../App";
import { AudioConnectivity } from "../Audio";


let defaultText = `"Fools!" the sorcerer snarls, "You'll never escape alive!"   The beast lunges — WHUMPH! — its claws slicing through the air.  You deftly leap aside as it slams into the pillar behind you with a CRACK!  The abomination glares at you and roars.  RAAWWWRRR!`;
function RealTimeTTS({ token }) {
    const [text, setText] = useState(defaultText);
    const [selectedVoice, setSelectedVoice] = useState("ash");
    const [isConnecting, setIsConnecting] = useState(false);
    const [userHasConnected, setUserHasConnected] = useState(false);
    const [isVADConnected, setIsVADConnected] = useState(false);
    const [isGMVoiceConnected, setIsGMVoiceConnected] = useState(false);
    const [userInput, setUserInput] = useState("");
    const [micMuted, setMicMuted] = useState(false);
    const [speakerMuted, setSpeakerMuted] = useState(false);
    const [voiceInputMode, setVoiceInputMode] = useState("vad"); // "vad" or "ptt"
    const [isRecording, setIsRecording] = useState(false);

    const BASE_URL = useContext(ApiContext);

    const audioConnectivityRef = useRef(null);

    useEffect(() => {
        if (!audioConnectivityRef.current) {

            const setUserInputCallback = (transcript) => {
                setUserInput(transcript);
            }

            audioConnectivityRef.current = new AudioConnectivity("DEMO", "DEMO", BASE_URL, setUserInputCallback);
        }
    }, [BASE_URL]);

    const handleTextChange = (e) => {
        setText(e.target.value);
    };

    useEffect(() => {
        if (userHasConnected && isVADConnected && voiceInputMode === "ptt") {
            audioConnectivityRef.current.disconnectUserVADConnection();
            setIsVADConnected(false);
        }

        if (userHasConnected && !isVADConnected && voiceInputMode === "vad") {
            audioConnectivityRef.current.initUserVADConnection(micMuted);
            setIsVADConnected(true);
        }
    }, [voiceInputMode, micMuted, isVADConnected, userHasConnected]);

    const handleVoiceChange = async (event) => {
        setSelectedVoice(event.target.value);
        if (isGMVoiceConnected) {
            audioConnectivityRef.current.disconnectGMVoiceConnection();
            setIsGMVoiceConnected(false);
            setIsConnecting(true);
            audioConnectivityRef.current.isGreeted = false;
            await audioConnectivityRef.current.initGMVoiceConnection(
                event.target.value
            );
            setIsGMVoiceConnected(true);
            setIsConnecting(false);
        }
    };

    const handleInitConnection = async () => {
        setIsConnecting(true);

        try {
            const gmSuccess = await audioConnectivityRef.current.initGMVoiceConnection(
                selectedVoice
            );
            setIsGMVoiceConnected(gmSuccess);

            if (voiceInputMode === "vad") {
                const userVADSuccess = await audioConnectivityRef.current.initUserVADConnection(micMuted);
                setIsVADConnected(userVADSuccess);
            }

            setUserHasConnected(true);
        } catch (error) {
            console.error("Failed to connect:", error);
        } finally {
            setIsConnecting(false);
        }
    };


    const handleDisconnectConnection = () => {
        audioConnectivityRef.current.disconnectGMVoiceConnection();
        audioConnectivityRef.current.disconnectUserVADConnection();
        audioConnectivityRef.current.isGreeted = false;
        setIsGMVoiceConnected(false);
        setIsVADConnected(false);
        setUserHasConnected(false);
        setMicMuted(false);
        setSpeakerMuted(false);
        setText(defaultText);
    };

    const submitText = () => {
        audioConnectivityRef.current.readText(text);
    };

    const handleToggleMic = () => {
        audioConnectivityRef.current.toggleMicMute();
        setMicMuted(prev => !prev);
    };

    const handleToggleSpeaker = () => {
        audioConnectivityRef.current.toggleSpeakerMute();
        setSpeakerMuted(prev => !prev);
    };

    useEffect(() => {
        if (userInput) {
            setText(userInput);
            audioConnectivityRef.current.readText(userInput);
        }
    }, [userInput]);

    const handleRecordButton = () => {
        if (voiceInputMode !== "ptt") return;

        if (isRecording) {
            // Stop recording logic here
            audioConnectivityRef.current?.handleRecordClick(); // (you'll implement this on the Audio side)
            setIsRecording(false);
        } else {
            // Start recording logic here
            audioConnectivityRef.current?.handleRecordClick();
            setIsRecording(true);
        }
    };

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: (theme) => theme.palette.background.default,
            color: (theme) => theme.palette.text.primary,
        }}>
            <h3>Gamemaster.chat v2 Voice I/O</h3>
            <br />

            <FormControl fullWidth style={{ maxWidth: 300 }}>

                <InputLabel id="dropdown-label">Select GM Voice</InputLabel>
                <Select
                    labelId="dropdown-label"
                    value={selectedVoice}
                    onChange={handleVoiceChange}
                    displayEmpty
                    disabled={isConnecting}
                >
                    <MenuItem value="alloy">Alloy</MenuItem>
                    <MenuItem value="ash">Ash</MenuItem>
                    <MenuItem value="ballad">Ballad</MenuItem>
                    <MenuItem value="coral">Coral</MenuItem>
                    <MenuItem value="echo">Echo</MenuItem>
                    <MenuItem value="sage">Sage</MenuItem>
                    <MenuItem value="shimmer">Shimmer</MenuItem>
                    <MenuItem value="verse">Verse</MenuItem>
                    {/*
                    <MenuItem value="nova">Nova</MenuItem>
                    <MenuItem value="onyx">Onyx</MenuItem>
                    <MenuItem value="fable">Fable</MenuItem>
                    */}
                </Select>
            </FormControl>
            <br />
            <FormControl fullWidth style={{ maxWidth: 300 }}>
                <InputLabel id="input-mode-label">Input Mode</InputLabel>
                <Select
                    labelId="input-mode-label"
                    value={voiceInputMode}
                    onChange={(e) => setVoiceInputMode(e.target.value)}
                    style={{ width: "300px" }}
                    disabled={isConnecting}
                >
                    <MenuItem value="vad">Voice Activity (VAD)</MenuItem>
                    <MenuItem value="ptt">Push-to-Talk (PTT)</MenuItem>
                </Select>
            </FormControl>

            <br />
            <div style={{ display: 'flex', gap: '10px' }}>
                <Button
                    onClick={() => { userHasConnected ? handleDisconnectConnection() : handleInitConnection() }}
                    style={{
                        margin: "10px",
                        padding: "10px 20px",
                        backgroundColor: isConnecting ? "#777" : "#007bff",
                        cursor: isConnecting ? "not-allowed" : "pointer",
                    }}
                    disabled={isConnecting}
                >
                    {userHasConnected ? "Disconnect" : "Connect"}
                </Button>
                <Button
                    variant="contained"
                    onClick={handleRecordButton}
                    disabled={voiceInputMode !== "ptt" || !userHasConnected}
                    style={{
                        margin: "10px",
                        padding: "10px 20px",

                    }}
                >
                    {isRecording ? "Stop Recording" : "Record (PTT)"}
                </Button>
            </div>




            <br />
            <TextField
                multiline
                fullWidth
                minRows={4} // minimum rows always visible
                maxRows={4}
                placeholder={userHasConnected ? "Enter text here..." : "Not connected"}
                value={text}
                onChange={handleTextChange}
                style={{
                    padding: "10px",
                    fontSize: "16px",
                    maxWidth: "300px",
                    cursor: userHasConnected ? "pointer" : "not-allowed",
                }}
                disabled={!userHasConnected}
            />

            <br />

            <Button
                variant="contained"
                onClick={submitText}
                style={{

                    cursor: userHasConnected ? "pointer" : "not-allowed",
                }}
                disabled={!userHasConnected}
            >
                {userHasConnected ? "Send Text" : "Connect to Send"}
            </Button>

            <br />

            <div style={{ display: 'flex', gap: '10px' }}>
                <Button variant="contained" onClick={handleToggleMic} disabled={!userHasConnected || !isVADConnected}>
                    {micMuted ? "Unmute Mic" : "Mute Mic"}
                </Button>

                <Button variant="contained" onClick={handleToggleSpeaker} disabled={!userHasConnected}>
                    {speakerMuted ? "Unmute GM" : "Mute GM"}
                </Button>
            </div>
            {isConnecting && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.75)', // Optional dim effect
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999, // ensure it's on top
                    }}
                >
                    <img
                        src="/loading.gif"
                        alt="Loading"
                        style={{ height: '100px', width: 'auto' }}
                    />
                </Box>
            )}
        </Box>

    );
}

export default RealTimeTTS;
